import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const ProjectCard = makeShortcode("ProjectCard");
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Projects🚀`}</h2>
    <ProjectCard title="Tasker" link="https://app-tasker.netlify.app/" bg="linear-gradient(to right, #D4145A 0%, #FBB03B 100%)" mdxType="ProjectCard">
  A personalized todo app where you can create, update, view and delete your
  tasks. You can use it to increase your productivity. More features are on the
  way ! Made entirely using MERN stack.
    </ProjectCard>
    <ProjectCard title="ExploreIt" link="https://exploreit.netlify.app/" bg="linear-gradient(to right, #6A2D8C 0%, #E91E7A 100%)" mdxType="ProjectCard">
  Search images from Unsplash and play Youtube videos at one place , using
  ReactJs !!
    </ProjectCard>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      